<template>
    <div>
        <app-header :settings='settings' :showdeclarers='showdeclarers'></app-header>

        <div class="page__head container">
            <div class="page__head-inner block">
                <!-- Для этой страницы стиль заголвока h2 -->
                <h1 class="page__title h2">Подключенные Лицевые счета:</h1>
            </div>
        </div>

        <div class="page__main container">
            <div class="page__index block-index">
                <div class="personal-section">
                    <div class="personal-section__link block">
                        <div class="add-drop">
                            <a href="" class="add-drop__toggle link link--underline" data-toggle="dropdown">
                                <div class="link__icon fab-icon">
                                    <i class="icon icon--add"></i>
                                </div>
                                <div class="link__text">Добавить Лицевой счет</div>
                            </a>
                            <div class="add-drop__drop">
                                <div class="add-drop__drop-inner">
                                    <a href="/profiles/add-individual/" class="button button--th-main">Добавить счет физического лица</a>
                                    <!--<a href="/profiles/add-entity/" class="button button--th-main">Добавить ЛС Юр. лица</a>-->
                                    <a href="/profiles/add-entitynew/" class="button button--th-main">Добавить ЛС Юр. лица</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <personal-account v-for="(account, indexPerson) in personAccounts"
                                    :key="indexPerson+1000000"
                                    :account="account"></personal-account>
                    <entity-account v-for="(account, indexEntity) in normalizedAccounts"
                                    :key="indexEntity"
                                    :account="account"></entity-account>
                </div>
            </div>

            <div class="page__aside block">
                <div class="aside">
                    <div class="aside__item aside__item--divider">
                        <div class="card-promo card-promo--hover card-promo--warning card">
                            <div class="card-promo__bg"></div>
                            <div class="card-promo__head">
                                <div class="card-promo__title h2">Есть вопросы?</div>
                            </div>
                            <div class="card-promo__body">
                                <div class="card-promo__text">
                                    Посмотрите раздел помощи,либо напишите нам лично.
                                </div>
                            </div>
                            <div class="card-promo__footer">
                                <a href="/faq" class="link link--underline"><span class="link__text">Помощь</span></a>
                                <a href="/faq/add" class="card-promo__button button button--th-ctrl">Задать вопрос</a>
                            </div>
                        </div>
                    </div>
                    <!--<div class="aside__item aside__item--divider">
                        <a href="" class="card-promo card-promo--hover card-promo--warning card">
                            <div class="card-promo__bg"></div>
                            <div class="card-promo__head">
                                <div class="card-promo__title h2">Законодательная база</div>
                            </div>
                            <div class="card-promo__body">
                                <div class="card-promo__text">Посмотрите раздел помощи,либо напишите нам лично.</div>
                            </div>
                            <div class="card-promo__footer">
                                <div class="more-link">
                                    <span class="link__text">Подробнее</span>
                                    <span class="more-link__icon fab-icon">
                                        <i class="icon icon--arrow-right"></i>
                                    </span>
                                </div>
                            </div>
                        </a>
                    </div>-->
                    <div class="aside__item aside__item--divider">
                        <a href="/UL/documentsrequests/dogovory-i-dokumenty" class="card-promo card-promo--hover card-promo--warning card">
                            <div class="card-promo__bg"></div>
                            <div class="card-promo__head">
                                <div class="card-promo__title h2">Образцы заявок</div>
                            </div>
                            <div class="card-promo__body">
                                <div class="card-promo__text">Посмотрите раздел помощи,либо напишите нам лично.</div>
                            </div>
                            <div class="card-promo__footer">
                                <div class="more-link">
                                    <span class="link__text">Подробнее</span>
                                    <span class="more-link__icon fab-icon">
                                        <i class="icon icon--arrow-right"></i>
                                    </span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import ProfilesHeader from './ProfilesHeader.vue';
    import EntityAccount from './EntityAccount.vue'
    import PersonalAccount from './PersonalAccount.vue'

    export default {
        name: 'personal',
        components: {
            'app-header': ProfilesHeader,
            'entity-account': EntityAccount,
            'personal-account': PersonalAccount
        },
		props: ['accounts', 'showdeclarers'],
        data: function () {
            return {
                settings: { name: this.$options.name }              
            }
        },
        computed: {
            normalizedAccounts: function () {
                console.info(JSON.parse(this.accounts).LegalAccounts);
                return JSON.parse(this.accounts).LegalAccounts;
            },
            personAccounts: function () {
                console.info(JSON.parse(this.accounts).PersonAccounts);
                return JSON.parse(this.accounts).PersonAccounts;
            }
        }
    }

</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/Personal.vue